var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOffer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.552 9.5C9.03729 9.5 11.052 7.48528 11.052 5C11.052 2.51472 9.03729 0.5 6.552 0.5C4.06672 0.5 2.052 2.51472 2.052 5C2.052 7.48528 4.06672 9.5 6.552 9.5Z",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.552 7C7.65657 7 8.552 6.10457 8.552 5C8.552 3.89543 7.65657 3 6.552 3C5.44743 3 4.552 3.89543 4.552 5C4.552 6.10457 5.44743 7 6.552 7Z",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68202 9.42L4.80202 13.12C4.78461 13.1903 4.75241 13.2561 4.70758 13.313C4.66275 13.3699 4.60631 13.4166 4.54202 13.45C4.47417 13.4795 4.40099 13.4946 4.32702 13.4946C4.25306 13.4946 4.17988 13.4795 4.11202 13.45L0.792025 12C0.722385 11.9671 0.661109 11.9188 0.612794 11.8588C0.564479 11.7988 0.530381 11.7287 0.51306 11.6536C0.49574 11.5786 0.495646 11.5005 0.512786 11.4254C0.529926 11.3503 0.563854 11.2801 0.612025 11.22L3.18202 8",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68213 9.37L8.58213 13.12C8.60003 13.1915 8.63352 13.2582 8.68019 13.3152C8.72687 13.3723 8.78559 13.4183 8.85213 13.45C8.91813 13.4798 8.98972 13.4952 9.06213 13.4952C9.13455 13.4952 9.20614 13.4798 9.27213 13.45L12.5721 12C12.6428 11.9675 12.7049 11.9189 12.7535 11.8581C12.8021 11.7974 12.8359 11.7261 12.8521 11.65C12.8711 11.5756 12.8719 11.4976 12.8545 11.4228C12.8371 11.348 12.802 11.2784 12.7521 11.22L10.0721 7.81",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffer);
export default __webpack_public_path__ + "static/media/offer.88f1345492b6072ae91a117ade1dbc6a.svg";
export { ForwardRef as ReactComponent };